module.exports = __webpack_public_path__ + "9eee4c5ce5023465cde3dd8fc88f0dbc.svg";